/**
 * Patches DOM methods to prevent React crashes caused by browser extensions
 * (Google Translate, Grammarly, etc.) that modify the DOM outside React's control.
 *
 * When extensions wrap text nodes in their own elements (e.g. <font>, <span>),
 * React's reconciliation fails with:
 * "NotFoundError: Failed to execute 'removeChild' on 'Node'"
 *
 * @see https://github.com/facebook/react/issues/11538
 * @see DESKTOP-ALLO-7G
 */
if (typeof Node !== 'undefined') {
  const originalRemoveChild = Node.prototype.removeChild;

  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      if (child.parentNode) {
        return originalRemoveChild.call(child.parentNode, child) as T;
      }
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;

  Node.prototype.insertBefore = function <T extends Node>(
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (referenceNode.parentNode) {
        return originalInsertBefore.call(referenceNode.parentNode, newNode, referenceNode) as T;
      }
      return originalInsertBefore.call(this, newNode, null) as T;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
